<template>
  <div>
    <BlBackdrop
      title="New Package Item"
      label="Create"
      :submitLoading="submitLoading"
      :disabled="isDisabledSubmit"
      @backdrop-close="$emit('close-modal')"
      @backdrop-action="onSubmit"
    >
      <div
        class="flex flex-col gap-4 overflow-y-auto"
        :style="{ width: '40rem', maxHeight: 'calc(100vh - 16rem)' }"
      >
        <div class="px-8 flex flex-col gap-4">
          <BlInputText :input="nameInput" @changed="inputHandler" />
          <BlInputText :input="descriptionInput" @changed="inputHandler" />
          <BlInputText
            :input="standardRetailPriceInput"
            @changed="inputHandler"
          />
        </div>
        <div class="w-full h-5 flex-shrink-0 bg-grey-100"></div>
        <div class="px-8 flex flex-col gap-4">
          <div class="flex flex-col gap-2">
            <BlTextSubtitle1 text="Provider" />
            <BlTextBody2
              text="Specify which therapists can provide this service. You can choose to make it available for everyone or limit it to selected therapists for more control over credit usage."
            />
          </div>
          <div
            v-for="opt in providerOptions"
            :key="opt.value"
            class="flex gap-4 cursor-pointer"
            @click="providerInput = opt.value"
          >
            <BlInputRadio
              :checked="providerInput === opt.value"
              name="provider"
            />
            <BlTextBody2 :text="opt.label" />
          </div>
          <div
            v-if="providerInput === 'restricted'"
            class="py-2 px-2 flex flex-col gap-2 bg-slate-200 rounded"
          >
            <div class="flex items-center justify-between">
              <BlTextBody2
                :text="`${usersInput.length} therapist(s) selected`"
              />
              <BlInputButton
                type="outlined"
                dense
                label="Add therapist"
                @clicked="usersMultiSelectOpened = true"
              />
            </div>
            <div v-if="usersInput.length" class="flex flex-col">
              <div
                v-for="user in usersInput"
                :key="user.id"
                class="py-2 flex items-center justify-between gap-4 border-b border-slate-400"
              >
                <BlTextSubtitle3
                  v-if="!user.name"
                  title="Deleted user"
                  text="Deleted user"
                  class="truncate italic"
                />
                <BlTextSubtitle3
                  v-else
                  :title="user.name"
                  :text="user.name"
                  class="truncate"
                />
                <BlTextBody2 :text="user.email" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </BlBackdrop>

    <UsersMultiSelect
      v-if="usersMultiSelectOpened"
      :list="usersInput"
      @change="usersInput = $event"
      @close-modal="usersMultiSelectOpened = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { displayPrice } from "@/plugins/helper.js";

import UsersMultiSelect from "../../modal/UsersMultiSelect.vue";

import BlBackdrop from "../../BlBackdrop.vue";
import BlTextSubtitle1 from "../../BlTextSubtitle1.vue";
import BlTextSubtitle3 from "../../BlTextSubtitle3.vue";
import BlTextBody1 from "../../BlTextBody1.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlTextBody3 from "../../BlTextBody3.vue";
import BlInputText from "../../BlInputText.vue";
import BlInputRadio from "../../BlInputRadio.vue";
import BlInputButton from "../../BlInputButton.vue";

export default {
  name: "NewPackageItemModal",
  components: {
    UsersMultiSelect,
    //
    BlBackdrop,
    BlTextSubtitle1,
    BlTextSubtitle3,
    BlTextBody1,
    BlTextBody2,
    BlTextBody3,
    BlInputText,
    BlInputRadio,
    BlInputButton
  },
  data() {
    return {
      submitLoading: false,
      nameInput: {
        label: "Name",
        asterisk: true,
        placeholder: "Type the name",
        model: ""
      },
      descriptionInput: {
        label: "Description",
        placeholder: "Type the description",
        textarea: true,
        model: ""
      },
      standardRetailPriceInput: {
        label: "SRP (Standard Retail Price)",
        inputType: "number",
        model: "0",
        prefix: "",
        prefixSpace: "3rem",
        suffix: "per credit"
      },
      providerInput: "available_for_everyone", // available_for_everyone or restricted
      providerOptions: [
        { value: "available_for_everyone", label: "Available for everyone" },
        { value: "restricted", label: "Restricted" }
      ],
      //
      usersMultiSelectOpened: false,
      usersInput: []
    };
  },
  computed: {
    ...mapGetters(["currentCenter"]),
    isDisabledSubmit() {
      if (!this.nameInput.model) return true;
      if (!this.standardRetailPriceInput.model) return true;
      return false;
    }
  },
  watch: {},
  mounted() {
    if (this.currentCenter) {
      this.standardRetailPriceInput.prefix = this.currentCenter.currency_sym;
    }
  },
  methods: {
    ...mapActions(["createCreditPackageItem"]),
    displayPrice,
    priceFormats(price = 0) {
      const settings = this.currentCenter.currency_settings;
      return this.displayPrice({ settings, price });
    },
    inputHandler(payload) {
      payload.input.model = payload.value;
    },
    async onSubmit() {
      const params = {
        package_item: {
          name: this.nameInput.model,
          description: this.descriptionInput.model,
          standard_retail_price: this.standardRetailPriceInput.model || 0,
          provider: this.providerInput,
          user_ids: []
        }
      };

      if (this.providerInput === "restricted") {
        params.package_item.user_ids = this.usersInput.map(i => i.id);
      }

      this.submitLoading = true;
      const { success } = await this.createCreditPackageItem(params);
      this.submitLoading = false;
      if (!success) return;
      this.$emit("close-modal");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/center/packageItem/NewPackageItemModal.vue